import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { knBrOccQuoteConfig } from 'src/feature-libs/kn-br-cart/saved-carts/occ/config/kn-br-occ-quote-config';
import { KnBrMyQuoteDownloadLinkModule } from './kn-br-my-quote-download-link/kn-br-my-quote-download-link.module';
import { KnBrMyQuoteCreateModule } from './kn-br-quote-create/kn-br-my-quote-create.module';
import { KnBrMyQuoteDetailModule } from './kn-br-quote-detail/kn-br-my-quote-detail.module';
import { KnBrMyQuoteItemsModule } from './kn-br-quote-detail/kn-br-my-quote-items/kn-br-quote-items.module';
import { KnBrMyQuoteSearchResultModule } from './kn-br-quote-search-result/kn-br-my-quote-search-result.module';
import { KnBrMyQuoteSearchModule } from './kn-br-quote-search/kn-br-my-quote-search.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KnBrMyQuoteSearchResultModule,
    KnBrMyQuoteSearchModule,
    KnBrMyQuoteDownloadLinkModule,
    KnBrMyQuoteCreateModule,
    KnBrMyQuoteDetailModule,
    KnBrMyQuoteItemsModule,
    ConfigModule.withConfig(knBrOccQuoteConfig),
  ],
})
export class KnBrMyQuoteModule {}
